module.exports = __webpack_public_path__ + "img/green_packaging.b697a264.jpg";